import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-darker-navy py-16 md:py-20 px-6" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-75">
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-6" data-id="element-76">
            Lo sientes en el aire cada vez que tu hijo llega de la escuela. Ese
            tono de voz que no es el suyo, esa mirada desafiante que aprendió en
            otro lado, o ese silencio pesado mientras se encierra en su cuarto
            con el teléfono pegado a la cara.
          </p>

          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-6" data-id="element-77">
            Sabes que alguien más lo está guiando. Y lo peor es que ese
            "alguien" podría ser un amigo con malas intenciones o un algoritmo
            de TikTok diseñado para alejarlo de tus valores.
          </p>
        </motion.div>
      </div>
    </section>;
}